import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMedia = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "currentColor",
	viewBox: "0 0 48 48",
	...props,
	children: /* @__PURE__ */ _jsx("switch", { children: /* @__PURE__ */ _jsxs("g", { children: [/* @__PURE__ */ _jsx("path", { d: "M45.13 39.945H2.87V8.056h42.26zm-39.26-3h36.26V11.056H5.87z" }), /* @__PURE__ */ _jsx("path", { d: "M33.082 24.174 17.71 15.076v18.195z" })] }) })
});
export default SvgMedia;
